<template>
    <LayoutWrapper
        :id="id"
        class="global-alignment-assistant-preset"
    >
        <LayoutPaddingSpace>
            <SequenceTypeBlock multiple />
            <AlgorithmTypeSection />
        </LayoutPaddingSpace>
        <LayoutDivider />
        <LayoutPaddingSpace>
            <LayoutContainer v-if="!isNw">
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.searchParameters') }}
                    </SectionTitle>
                    <SectionBlock>
                        <MultiSubjectLengthField v-if="store.isMultiDbType" />
                        <SubjectLengthField v-else />
                    </SectionBlock>
                </LayoutColumn>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.algorithmSettings') }}
                    </SectionTitle>
                    <SectionBlock>
                        <MatchWithGapsField />
                        <EvalueField />
                        <LowComplexRegionField />
                    </SectionBlock>
                </LayoutColumn>
            </LayoutContainer>
            <Collapse v-if="!isNw" v-model="proxyExpand">
                <span slot="label">{{ $t('Search.labels.nonShortSequence') }}</span>
                <LayoutContainer>
                    <LayoutColumn>
                        <SectionBlock>
                            <AlignmentIdentityField />
                            <QueryIdentityField />
                            <QueryCoverageField />
                            <SubjectIdentityField />
                            <SubjectCoverageField />
                        </SectionBlock>
                    </LayoutColumn>
                    <LayoutColumn>
                        <AlgorithmBlock v-if="!store.algorithmSettingsDisabled" />
                    </LayoutColumn>
                </LayoutContainer>
            </Collapse>
            <slot v-if="!isNw" />
            <GlobalAlignmentSettings v-else>
                <template #before-fields>
                    <SubjectLengthField />
                </template>
                <template #extra-fields>
                    <MaxTargetSequenceField :limitOptions="limitOptions" />
                </template>
            </GlobalAlignmentSettings>
        </LayoutPaddingSpace>
        <ResetSection />
    </LayoutWrapper>
</template>

<script>
import _ from 'lodash';
import { BioSearchSettingProvider } from '@patsnap-biz/bio-search-setting';
import AlgorithmBlock from '@patsnap-biz/bio-search-setting/src/presets/Algorithm.prefab.vue';
import SequenceTypeBlock from '@patsnap-biz/bio-search-setting/src/presets/SequenceType.prefab.vue';
import { SEQUENCE_LIMIT_OPTIONS } from '@patsnap-biz/bio-search-setting/src/constants/constantConfig';
import { BIO_SEARCH_ALGORITHM_TYPES } from '../../utils/global-alignment';
import GlobalAlignmentSettings from './global-alignment-settings.vue';

export default {
    name: 'GlobalAlignmentAssistantPreset',
    components: {
        AlgorithmBlock,
        GlobalAlignmentSettings,
        SequenceTypeBlock,
    },
    extends: BioSearchSettingProvider,
    inject: {
        state: {
            from: 'state',
            default: null,
        },
    },
    data() {
        return {
            expand: false,
            hasInitializedNwSubjectLength: false,
        };
    },
    computed: {
        isNw() {
            return this.store.algorithmType === BIO_SEARCH_ALGORITHM_TYPES.Nw;
        },
        proxyExpand: {
            get() {
                return this.state ? this.state.manualExpand : this.expand;
            },
            set(value) {
                if (this.state) this.state.manualExpand = value;
                this.expand = value;
            },
        },
        limitOptions() {
            return _.map(SEQUENCE_LIMIT_OPTIONS, option => ({
                ...option,
                ...(option.tooltip
                    ? { tooltip: this.$tc(option.tooltip) }
                    : {}),
            }));
        },
    },
    watch: {
        isNw: {
            immediate: true,
            handler(isNw) {
                if (!isNw || this.hasInitializedNwSubjectLength) return;

                this.hasInitializedNwSubjectLength = true;
                const subjectLength = this.store.settingValues.subject_length;
                const isDefaultUnbounded = !subjectLength
                    || (
                        [0, '0'].includes(subjectLength[0])
                        && ['', undefined].includes(subjectLength[1])
                    );
                if (!isDefaultUnbounded) return;

                this.store.$set(this.store.settingValues, 'subject_length', [0, 100]);
                this.store.writeFieldValue('subject_length');
            },
        },
    },
};
</script>

<style lang="scss">
.global-alignment-assistant-preset {
    .search-preference__alg-label .search-preferences--radio {
        display: inline-flex;
        align-items: center;
        min-height: 24px;

        input[type="radio"] {
            flex: 0 0 14px;
            width: 14px;
            height: 14px;
            margin: 0;
        }
    }
}
</style>
